var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import AssetLoader from "../loader/AssetLoader.js";
import { animate } from "../utils/render.js";
import { Box } from "./Box.js";
import "../loader/ImageLoader.js";
import "../global-33d5eebf.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "./UIElement.js";
import "./Rectangle.js";
import "nanoid";
import "./utils.js";
import "lodash";
import "./UIService.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
class AnimatedImageBox extends Box {
  constructor(rect, _config) {
    super(rect, _config);
    __publicField(this, "animationInterval");
    if (this._config.animationSpeed !== 0) {
      this.animationInterval = setInterval(() => {
        this._config.frame++;
      }, this._config.animationSpeed * 1e3);
    }
  }
  updateImage(spriteKey) {
    this._config.spriteKey = spriteKey;
  }
  updateAnimation(animationKey) {
    this._config.animationKey = animationKey;
  }
  setAnimationFrame(frame) {
    this._config.frame = frame;
  }
  calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight, xoffset = 0, yoffset = 0) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return {
      width: srcWidth * ratio,
      height: srcHeight * ratio,
      xoffset,
      yoffset
    };
  }
  drawInternal(ctx, ui) {
    if (!this._config.spriteKey) {
      return;
    }
    const img = AssetLoader.getInstance().getImage(this._config.spriteKey);
    const padding = this._config.padding !== void 0 ? this._config.padding : 5;
    const widthWithPadding = this.bounds.width - padding * 2;
    const heightWithPadding = this.bounds.height - padding * 2;
    const resizedImageBounds = this.calculateAspectRatioFit(
      img.width,
      img.height,
      widthWithPadding,
      heightWithPadding,
      img.xoffset,
      img.yoffset
    );
    animate(ctx, this._config.animationKey, this._config.frame, {
      x: this.bounds.x + padding + resizedImageBounds.width / 2 - (this._config.xoffset ?? 0),
      y: this.bounds.y + padding + resizedImageBounds.height / 2 - (this._config.yoffset ?? 0),
      width: resizedImageBounds.width,
      height: resizedImageBounds.height,
      xoffset: resizedImageBounds.xoffset,
      yoffset: resizedImageBounds.yoffset
    });
  }
}
export {
  AnimatedImageBox
};
//# sourceMappingURL=AnimatedImageBox.js.map
